import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import InputAdornment from "@material-ui/core/InputAdornment";
import * as Utils from '../../../../common/utilSvc';
import { isNullOrUndefined } from "util";
import './userEmailAsk.css';


class UserEmailAsk extends React.Component {
    
    constructor(props){

        super(props);
        
        this.state = {
            emailId: ''
        }

        this.canSave = this.canSave.bind(this);
        this.saveDetails = this.saveDetails.bind(this);
        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(event, type, index){
        if(type=="email"){
            let emailId = this.state.emailId;
            emailId = event.target.value;
            if(!isNullOrUndefined(emailId)){
                emailId = emailId.replace("\n","").replace(" ","");
            }
            this.setState({emailId: emailId});            
        }
    }

    canSave(){
        let emailId = this.state.emailId;
        emailId= emailId.trim();
        return Utils.validateEmail(emailId);
    }

    saveDetails(){
        this.props.saveUserEmail(this.state.emailId.trim());
    }

    render(){
        let scope = this;
        return (
            <div className="userEmailAskContainer">
                <p style={{fontSize:'16px',fontWeight:'bold'}}>Enter your email to unlock additional content</p>
                <form>
                    <label>
                        <TextField 
                            type="text"
                            variant="outlined"
                            multiline
                            placeholder = "Enter your email"
                            value={this.state.emailId}
                            onChange={(e) => { this.handleChange(e,"email")}}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    if(scope.canSave()){
                                        scope.saveDetails();
                                    }
                                }
                             }}
                            rowsMax="2"
                            rowsMin="1"
                            InputProps={{
                                endAdornment: (
                                  <InputAdornment>
                                  {scope.canSave()?
                                        <IconButton onClick={this.saveDetails}>
                                            <DoneAllIcon />
                                        </IconButton>
                                        :
                                        null
                                  }
                                  </InputAdornment>
                                )
                              }}
                            style={{
                                background: 'white',
                                marginTop:'6px',
                                marginBottom:'6px',
                                width:'95%',
                                maxWidth:'550px',
                                minWidth: '200px'
                                }}/>
                    </label>
                </form>
                {this.canSave()?
                    <div style={{marginTop:'-3px', marginBottom:'6px',}}>
                        <Button 
                            color="primary"
                            variant="contained"
                            className="genericButton_v1" 
                            onClick={() => {this.saveDetails()}}>                                
                            Confirm email
                        </Button>
                    </div>
                    :
                    null
                }
            </div>
        )
    }
}
export default UserEmailAsk;